import { render, staticRenderFns } from "./deleteHousekeepingType.vue?vue&type=template&id=2014d256&scoped=true"
import script from "./deleteHousekeepingType.vue?vue&type=script&lang=js"
export * from "./deleteHousekeepingType.vue?vue&type=script&lang=js"
import style0 from "./deleteHousekeepingType.vue?vue&type=style&index=0&id=2014d256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2014d256",
  null
  
)

export default component.exports